import { createSelector } from 'reselect';
import get from 'lodash/get';
import { makeSelectorFactory } from '../../utils/redux/selectAdapter';

export const selectAuthState = state => get(state, 'auth');

const getSelectors = makeSelectorFactory(selectAuthState);

export const selectAuthStatus = createSelector(
  selectAuthState,
  auth => get(auth, 'status'),
);

export const selectAuthLoggedInStatus = createSelector(
  selectAuthStatus,
  status => get(status, 'loggedIn', false),
);

export const selectSuccessAuthAzureForSignUpFlow = createSelector(
  selectAuthState,
  auth => get(auth, 'loginAzure.successAuthForSignUpFlow', false),
);

export const selectResetPassword = createSelector(
  selectAuthState,
  state => get(state, 'resetPassword'),
);

export const selectResetPasswordError = createSelector(
  selectResetPassword,
  state => get(state, 'error'),
);

export const selectResetPasswordSucceed = createSelector(
  selectResetPassword,
  state => get(state, 'succeed'),
);

export const authTokenSelector = state =>
  get(state, 'auth.status.authenticationToken');

export const isLoggedInSelector = state => !!get(state, 'auth.status.loggedIn');

export const selectAuthLogout = createSelector(
  selectAuthState,
  state => get(state, 'logout'),
);

export const selectAuthLogoutError = createSelector(
  selectAuthLogout,
  state => get(state, 'error'),
);

export const selectRequestPasswordUpdate = createSelector(
  selectAuthStatus,
  state => get(state, 'requestPasswordUpdate', false),
);

export const selectRegistrationCompleted = createSelector(
  selectAuthStatus,
  state => get(state, 'registrationCompleted', false),
);

export const selectLoggedUserId = createSelector(
  selectAuthStatus,
  state => get(state, 'loggedUserId', false),
);

export const {
  selectStateSucceed: selectSendInvitationSucceed,
  selectStatePending: selectSendInvitationPending,
  selectStateError: selectSendInvitationError,
} = getSelectors('sendInvitation');

export const selectAuthLoginData = createSelector(
  selectAuthState,
  auth => get(auth, 'login'),
);



// WEBPACK FOOTER //
// ./src/redux/auth/selectors.js